import { API_ENDPOINTS } from '@/constants';
import type {
  Manager,
  GetDirectReportsOutputDTO,
  GetMeResponseDTO,
} from '@/types';

import type { ApiBuilder } from './types';

/**
 * Auth API endpoints
 * All endpoints use the /auth base path
 */
export const authApi = (builder: ApiBuilder) => ({
  /**
   * Get the current authenticated user
   * GET /auth/me
   */
  getMe: builder.query<GetMeResponseDTO, void>({
    query: () => API_ENDPOINTS.AUTH.ME,
    providesTags: ['Auth'],
  }),

  /**
   * Get the current user's manager (who they report to)
   * GET /auth/manager
   */
  getManager: builder.query<Manager, void>({
    query: () => API_ENDPOINTS.AUTH.MANAGER,
    providesTags: ['Auth'],
  }),

  /**
   * Get users who report to the current user (direct reports)
   * GET /auth/direct-reports
   * Requires ManagerGuard (user must be a manager)
   */
  getDirectReports: builder.query<GetDirectReportsOutputDTO, void>({
    query: () => API_ENDPOINTS.AUTH.DIRECT_REPORTS,
    providesTags: ['Auth'],
  }),
});
